export const BMI = (weight, height) =>{
        let bmi = weight / ((height/100)*(height/100));
        
        if(bmi < 18.5){
          return `BMI = ${bmi.toFixed(2)} Berat Badan Kurang (Underweight)`;
        }else if (bmi.toFixed(2) < 24.9){
          return `BMI = ${bmi.toFixed(2)} Berat Badan Normal`;
        }else if (bmi.toFixed(2) < 29,9){
          return `BMI = ${bmi.toFixed(2)} Kelebihan berat Badan (Overweight)`;
        }else{
          return `BMI = ${bmi.toFixed(2)} (Obese)`;
        }
}
export const BMICount = (weight, height) =>{
  let bmi = weight / ((height/100)*(height/100));
  
  return bmi
}
export const BmiCss = (weight, height) =>{
    let bmi = weight / ((height/100)*(height/100));
    
    if(bmi < 18.5){
      return `badge badge-pill badge-danger`;
    }else if (bmi.toFixed(2) <= 22.9){
      return `badge badge-pill badge-success`;
    }else if (bmi.toFixed(2) <= 24,9){
      return `badge badge-pill badge-warning`;
    }else{
      return `badge badge-pill badge-danger`;
    }
}

export const BloodPress = (sistole, diastole) =>{
  if(sistole < 120 || diastole < 80){
    return `Tekanan Darah Normal`;
  }else if (sistole >= 120 && sistole <= 139 || diastole >= 80 && diastole <= 89){
    return `Prehipertensi`;
  }else if (sistole >= 140 && sistole <= 159 || diastole >= 99 && diastole <= 99){
    return `Hipertensi Stage I`;
  }else if (sistole >= 160 || diastole >= 100){
    return `Hipertensi Stage II`;
  }
}

export const BloodPressCss = (sistole, diastole) =>{
  if(sistole < 120 || diastole < 80){
    return `badge badge-pill badge-success`;
  }else if (sistole >= 120 && sistole <= 139 || diastole >= 80 && diastole <= 89){
    return `badge badge-pill badge-warning`;
  }else if (sistole >= 140 && sistole <= 159 || diastole >= 99 && diastole <= 99){
    return `badge badge-pill badge-danger`;
  }else if (sistole >= 160 || diastole >= 100){
    return `badge badge-pill badge-danger`;
  }
}